export const PERIODO_DECLARACION_MODELO_ENUM = {
  Mes_1: 1,
  Mes_2: 2,
  Mes_3: 3,
  Mes_4: 4,
  Mes_5: 5,
  Mes_6: 6,
  Mes_7: 7,
  Mes_8: 8,
  Mes_9: 9,
  Mes_10: 10,
  Mes_11: 11,
  Mes_12: 12,
  Trimestre_1: 13,
  Trimestre_2: 14,
  Trimestre_3: 15,
  Trimestre_4: 16,
} as const

export type PeriodoDeclaracionModeloEnumType =
  (typeof PERIODO_DECLARACION_MODELO_ENUM)[keyof typeof PERIODO_DECLARACION_MODELO_ENUM]
